'use client';

import { useLocale, useTranslations } from 'next-intl';
import { useSuspenseQuery } from '@apollo/client';
import { SearchReviews } from '@/query';

import { ReviewsCard } from './Card';
import { Pagination } from './Pagination';
import { useParams } from 'next/navigation';

const Reviews = () => {
  const params = useParams();
  const locale = useLocale();
  const [page = 1] = params.slug || [];
  const t = useTranslations();

  const { data } = useSuspenseQuery(SearchReviews, {
    variables: {
      page: Number(page),
      locale,
    },
    errorPolicy: 'ignore',
  });

  const reviews = data?.guestReviews?.collection || [];
  const totalPages = data?.guestReviews?.metadata?.totalPages || 1;

  return (
    <div className="page-wrapper 3xl:space-y-3">
      <>
        {reviews.length ? (
          <>
            <div className="container max-sm:pb-8 sm:max-lg:pb-8 lg:pb-[46px] pt-8 3xl:pt-[46px] 3xl:rounded-10">
              <h1 className="text-primary-800 mb-8 max-md:text-2xl md:text-[40px] font-semibold">
                {t('main.reviews.list.title')}
              </h1>
              <div className="tab-content grid md:grid-cols-2 gap-y-6 gap-x-8">
                {reviews.map((item) => (
                  <ReviewsCard key={item.id} item={item} />
                ))}
              </div>
              {totalPages > 1 && (
                <Pagination page={Number(page)} totalPages={totalPages} />
              )}
            </div>
          </>
        ) : null}
      </>
    </div>
  );
};

export default Reviews;
